import { render } from "./overview.vue?vue&type=template&id=15e724ac"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"

import "./overview.vue?vue&type=style&index=0&id=15e724ac&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/dashboard/main/overview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15e724ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15e724ac', __exports__)) {
    api.reload('15e724ac', __exports__)
  }
  
  module.hot.accept("./overview.vue?vue&type=template&id=15e724ac", () => {
    api.rerender('15e724ac', render)
  })

}


export default __exports__